export default [
    {
        path: "cart/:plan?",
        name: "cart",
        meta: {
            title: "Complete your payment",
            layout: "NoHeader"
        },
        alias: "krepselis/:plan?",
        component: () =>
            import(
                /* webpackChunkName: "Cart" */ "../views/Cart/CartWrapper.vue"
                ),
    },
    {
        path: "successful-payment",
        meta: {
            title: "Your payment was successful",
            layout: "NoHeader"
        },
        alias: ["sekmingas-apmokejimas"],
        component: () =>
            import("../views/Public/SuccessfulPayment.vue"),
    },
    {
        path: "unsuccessful-payment",
        meta: {
            title: "Your payment have failed",
            layout: "NoHeader"
        },
        alias: ["nesekmingas-apmokejimas"],
        component: () =>
            import("../views/Public/UnsuccessfulPayment.vue"),
    }
]
